import React from "react";

const MetricCard = ({ title, value, icon: Icon, color = "danger" }) => {
  return (
    <div className="metric-card">
      <div className={`d-flex align-items-center gap-2 text-${color} mb-2`}>
        <div className="icon bg-danger rounded p-2 text-white ">
          <Icon size={20} />
        </div>
        <div>
          <span className="fw-medium text-muted">{title}</span>
          <div className="metric-value">{value}</div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
